export const SIGNATURE_SERVER_URL =
    'https://webapi.tobit.com/AccountService/v1.0/General/PersonKeyValue/signature';
